import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ProgramacionRegidas } from './programacion-recogidas';
import { ListadoSolicitudes } from './listado-solicitudes';
import { ListadoSolicitudesDirectas } from './listado-solicitudes-directas';



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  
  export default function TabProgramacion() {
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Programacion de recogidas" {...a11yProps(0)} />
          {/*   <Tab label="Solicitudes directas" {...a11yProps(1)} /> */}
            <Tab label="Solicitudes por Aprobar" {...a11yProps(1)} />
            
        
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ProgramacionRegidas />
        </CustomTabPanel>
    {/*     <CustomTabPanel value={value} index={1}>
           <ListadoSolicitudesDirectas />
        </CustomTabPanel> */}
        <CustomTabPanel value={value} index={1}>
           <ListadoSolicitudes />
        </CustomTabPanel>
      
      </Box>
    );
  }